import { NgModule } from '@angular/core';

import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [],
  exports: [MatMenuModule],
})
export class MaterialModule {}
